import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4eccfa4d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-5" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "max-w-screen-xl mx-auto" }
const _hoisted_4 = { class: "flex flex-wrap -mx-4" }
const _hoisted_5 = { class: "w-full lg:w-1/4 px-3" }
const _hoisted_6 = { class: "mb-5" }
const _hoisted_7 = { class: "card w-75 shadow-xl" }
const _hoisted_8 = { class: "card-body items-center text-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Miniature", -1))
const _hoisted_10 = { class: "card-body items-center text-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Icone 3d", -1))
const _hoisted_12 = { class: "w-full lg:w-3/4 px-4" }
const _hoisted_13 = { class: "card w-full shadow-xl" }
const _hoisted_14 = { class: "card-body" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Général", -1))
const _hoisted_16 = { class: "w-full" }
const _hoisted_17 = { class: "mt-2" }
const _hoisted_18 = { class: "flex" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-3" }, [
  /*#__PURE__*/_createElementVNode("label", { for: "status" }, "Statut")
], -1))
const _hoisted_20 = { class: "card-actions" }
const _hoisted_21 = { key: 0 }

import { onBeforeMount, ref } from 'vue';
import { useRoute } from 'vue-router';
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";
import { useRouter } from "vue-router";
import UploadImage from "@/components/forms/UploadImage.vue";
import { ICategory } from "@/models/category/ICategory";
import { ICategoryForm } from "@/models/category/ICategoryForm";
import { fetchCategory } from "@/_services/category/category";

const submitBtnLabel = 'Editer';

export default /*#__PURE__*/_defineComponent({
  __name: 'EditCategoryForm',
  setup(__props) {

const title = ref<string>("Edition de catégorie");
const isEditSubCategory = ref<boolean>(false);
const category = ref<ICategory>({} as ICategory);
const route = useRoute();
const uuidRouteParam = ref<string>("");
const router = useRouter();
const loading = ref<boolean>(true);

onBeforeMount(async () => {
  uuidRouteParam.value = route.params.uuid.length ? route.params.uuid as string : "";
  if (uuidRouteParam.value.length) {
    category.value = await fetchCategory(uuidRouteParam.value);
    await hydrateCategoryForm(category.value);
    title.value = category.value.lvl > 1 ? "Edition de sous-catégorie" : "Edition de catégorie"
    isEditSubCategory.value = category.value.lvl > 1;
    originalForm.value = form.value;
    loading.value = false;
  }
});

const form = ref<ICategoryForm>({
  name: '',
  slug: '',
  description: '',
  parent: null,
  parentValue: null,
  enabled: true,
  vignette: null,
  icon3d: null  ,
});
const originalForm = ref<ICategoryForm>({
  name: '',
  slug: '',
  description: '',
  parent: null,
  parentValue: null,
  enabled: true,
  vignette: null,
  icon3d: null  ,  
});

const hydrateCategoryForm = (category: ICategory) => {
    console.log(category.icon3d);
  form.value = {
    name: category.name,
    slug: category.slug,
    description: category.description,
    enabled: category.enabled,
    parent: category.parentObject,
    parentValue: null,
    vignette: category.vignette, 
    icon3d: category.icon3d,  
  }
}

const onSubmit = async (formData, formNode) => {
  try {
    const payload = {
      name: formData.name,
      slug: formData.slug,
      description: formData.description,
      enabled: formData.status,
      vignette: null !== form.value.vignette ? `/api/images/${form.value.vignette.uuid}` : null, 
      icon3d: null !== form.value.icon3d ? `/api/images/${form.value.icon3d.uuid}` : null
    }
    swal.confirm(
      isEditSubCategory.value === false
      ? `Êtes-vous sûr de vouloir ${submitBtnLabel} cette catégorie ?`
      : `Êtes-vous sûr de vouloir ${submitBtnLabel} cette sous-catégorie ?`,
      "Annuler",
      submitBtnLabel
    )
    .then((results) => results.isConfirmed && updateCategorie(payload))
  } catch (err: any) {
    swal.error(err.errors[0]);
  }
}

const updateCategorie = (data) => {
  if(uuidRouteParam.value.length) {
    ApiService.patch('categories', uuidRouteParam.value, data)
    .then((response) => {
      swal.info("La catégorie " + response.data.data.name + " a été édité avec succès")
      .then((result) => {
        if (result.isConfirmed) {
          category.value.parentObject?.lvl === 0
            ? router.push({ name: "listCategories" })
            : router.push({
              name: "listCategories",
              params: { uuid: category.value.parentObject?.uuid },
            });
        }
    });
    })
    .catch((error) => {
      swal.error("Une erreur est survenue lors de la modification de la catégorie");
    });
  }
}

const onCancel = () => {
  swal.confirm(
    isEditSubCategory.value === false
      ? "Êtes-vous sûr de vouloir annuler l'édition de la catégorie ?"
      : "Êtes-vous sûr de vouloir annuler l'édition de la sous-catégorie ?",
    "Oui",
    "Non"
  ).then((result) => {
      if (result.isDismissed) {
        router.push({
          name: "listCategories",
          params: { uuid: category.value.parentObject?.uuid },
        });
      }
  });
}

const onImageUpload = (image) => {
  form.value.vignette = image;
}

const onImageRemoved = () => {
  form.value.vignette = null;
}

const onImageUpload3d = (image) => {
    form.value.icon3d = image;
}

const onImageRemoved3d = () => {
    form.value.icon3d = null;
}

const onImageUploadError = (errorMsg: string) => {
  swal.error(errorMsg);
}

function getBaseUrl() {
  return window.location.origin;
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(title.value), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(UploadImage, {
                  "image-preview-url": form.value.vignette ? form.value.vignette.url : getBaseUrl() + '/media/blank2.png',
                  onImageRemoved: onImageRemoved,
                  onImageUploaded: onImageUpload,
                  onError: onImageUploadError
                }, null, 8, ["image-preview-url"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(UploadImage, {
                  "image-preview-url": form.value.icon3d ? form.value.icon3d.url : getBaseUrl() + '/media/blank2.png',
                  onImageRemoved: onImageRemoved3d,
                  onImageUploaded: onImageUpload3d,
                  onError: onImageUploadError,
                  acceptedExtensions: ['.png']
                }, null, 8, ["image-preview-url", "acceptedExtensions"])
              ])
            ], 512), [
              [_vShow, isEditSubCategory.value === false]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_FormKit, {
                  type: "form",
                  actions: false,
                  model: form.value,
                  onSubmit: onSubmit,
                  "outer-class": "w-full",
                  "incomplete-message": "Veuillez remplir tous les champs correctement"
                }, {
                  default: _withCtx(({ state: { valid } }) => [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createElementVNode("div", null, [
                          _createElementVNode("span", {
                            class: _normalizeClass({
                        'badge': true,
                        'badge-error': !form.value.enabled,
                        'badge-success': form.value.enabled,
                        'badge-circle': true
                      })
                          }, null, 2)
                        ])
                      ]),
                      _createVNode(_component_FormKit, {
                        type: "select",
                        name: "status",
                        modelValue: form.value.enabled,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.enabled) = $event)),
                        help: "Faire apparaitre ou non la catégorie dans le catalogue",
                        options: [
                      { label: 'Activé', value: true },
                      { label: 'Désactivé', value: false },
                    ]
                      }, null, 8, ["modelValue"])
                    ]),
                    _createVNode(_component_FormKit, {
                      type: "text",
                      name: "slug",
                      modelValue: form.value.slug,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.slug) = $event)),
                      label: "Slug *",
                      validation: "required | matches:/^[^\\s][a-zA-Z0-9-_/%]*$/",
                      "validation-messages": {
                    required: 'Le slug est obligatoire',
                    matches: 'Le slug ne doit contenir que des lettres, des chiffres, des tirets et des slashs et ne doit pas commencer par un espace',
                  }
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_FormKit, {
                      type: "text",
                      name: "name",
                      label: "Nom *",
                      modelValue: form.value.name,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.name) = $event)),
                      validation: "required | length:1,30",
                      "validation-messages": {
                    required: 'Le nom est obligatoire',
                    length: 'Le nom ne doit pas dépasser 30 caractères',
                  }
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_FormKit, {
                      type: "textarea",
                      name: "description",
                      label: "Description",
                      modelValue: form.value.description,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.description) = $event)),
                      validation: "length:0,255",
                      "validation-messages": {
                    length: 'La description ne doit pas dépasser 255 caractères',
                  }
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_20, [
                      (loading.value === false)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createVNode(_component_FormKit, {
                              type: "submit",
                              label: submitBtnLabel,
                              disabled: !valid,
                              class: _normalizeClass({ 'btn-primary': true, 'btn-block': true })
                            }, null, 8, ["disabled"])
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_FormKit, {
                        type: "button",
                        label: "Annuler",
                        onClick: onCancel,
                        class: _normalizeClass({ 'btn-secondary': true, 'btn-block': true })
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["model"])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})